import styled from "styled-components";

export const WrapStyled = styled.div`
  margin-bottom: 1rem;
`;

export const HeadingStyled = styled.h4`
  color: ${({ theme }) => theme.colors.blueDianne};
`;
